import React from 'react';
import { ChevronLeftIcon, UploadIcon } from 'lucide-react';
interface HeaderProps {
  totalCount: number;
  filteredCount: number;
  onUploadClick?: () => void;
}
export function Header({
  totalCount,
  filteredCount,
  onUploadClick
}: HeaderProps) {
  return <div className="bg-geniac-bg border-b border-geniac-border px-5 py-3 flex-shrink-0 flex items-center justify-between" data-id="element-190">
      <div className="flex items-center gap-3 flex-1" data-id="element-191">
        <button className="text-geniac-muted hover:text-geniac-text transition-colors" data-id="element-192">
          <ChevronLeftIcon className="w-5 h-5" data-id="element-193" />
        </button>
        <span className="text-base font-semibold text-geniac-text tracking-tight" data-id="element-194">
          Geniac<span className="text-geniac-accent" data-id="element-195">.io</span>
        </span>
        <span className="text-[10px] font-semibold uppercase tracking-wider text-geniac-accent bg-geniac-accent/15 px-1.5 py-0.5 rounded" data-id="element-196">
          Beta
        </span>
      </div>

      <div className="flex items-center justify-center flex-1 text-center" data-id="element-197">
        <h1 className="text-sm font-medium text-geniac-text" data-id="element-198">
          Martinez v. Acme Corp et al.
        </h1>
        <span className="text-sm text-geniac-muted ml-3" data-id="element-199">
          — {filteredCount.toLocaleString()} of {totalCount.toLocaleString()}{' '}
          responses
        </span>
      </div>

      <div className="flex items-center justify-end flex-1 gap-4" data-id="element-200">
        {onUploadClick && <button onClick={onUploadClick} className="flex items-center gap-1.5 text-sm font-medium text-geniac-accent hover:text-geniac-accent/80 transition-colors" data-id="element-201">
            <UploadIcon className="w-4 h-4" data-id="element-202" />
            Upload
          </button>}
        <button className="text-sm text-geniac-muted hover:text-geniac-text transition-colors" data-id="element-203">
          Logout
        </button>
      </div>
    </div>;
}